"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var Navigation_1 = require("../../components/Navigation");
var Payments = function (props) {
    var paymentsText = (0, react_redux_1.useSelector)(function (state) { var _a; return (_a = state.app.chain) === null || _a === void 0 ? void 0 : _a.payments_text; });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Navigation_1.Navigation, {}), (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "grid static-page" }, { children: paymentsText })) }))] }));
};
exports.default = Payments;
